import api from '@/utils/api';

/**
 * delete customer
 *
 * @param {string} customerId - The customer id
 * @returns {Promise} The promise object of the api call
 */
const deleteCustomerApi = (customerId) => api.delete(`customer/${customerId}`);

export default deleteCustomerApi;
